export default "__VITE_ASSET__Bht1ivu9__"